// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN RUST INSTEAD.

// @ts-ignore
import { __SPACETIMEDB__, AlgebraicType, ProductType, BuiltinType, ProductTypeElement, DatabaseTable, AlgebraicValue, ReducerArgsAdapter, SumTypeVariant, Serializer, Identity, Address, ReducerEvent, Reducer, SpacetimeDBClient } from "@clockworklabs/spacetimedb-sdk";

export class UpdateElementFolderReducer extends Reducer
{
	public static reducerName: string = "UpdateElementFolder";
	public static call(_elementId: number, _folderId: number | null) {
		this.getReducer().call(_elementId, _folderId);
	}

	public call(_elementId: number, _folderId: number | null) {
		const serializer = this.client.getSerializer();
		let _elementIdType = AlgebraicType.createPrimitiveType(BuiltinType.Type.U32);
		serializer.write(_elementIdType, _elementId);
		let _folderIdType = AlgebraicType.createSumType([
			new SumTypeVariant("some", AlgebraicType.createPrimitiveType(BuiltinType.Type.U32)),
			new SumTypeVariant("none", AlgebraicType.createProductType([
		])),
		]);
		serializer.write(_folderIdType, _folderId);
		this.client.call("UpdateElementFolder", serializer);
	}

	public static deserializeArgs(adapter: ReducerArgsAdapter): any[] {
		let elementIdType = AlgebraicType.createPrimitiveType(BuiltinType.Type.U32);
		let elementIdValue = AlgebraicValue.deserialize(elementIdType, adapter.next())
		let elementId = elementIdValue.asNumber();
		let folderIdType = AlgebraicType.createSumType([
			new SumTypeVariant("some", AlgebraicType.createPrimitiveType(BuiltinType.Type.U32)),
			new SumTypeVariant("none", AlgebraicType.createProductType([
		])),
		]);
		let folderIdValue = AlgebraicValue.deserialize(folderIdType, adapter.next())
		let folderId = folderIdValue.asSumValue().tag == 1 ? null : folderIdValue.asSumValue().value.asNumber();
		return [elementId, folderId];
	}

	public static on(callback: (reducerEvent: ReducerEvent, _elementId: number, _folderId: number | null) => void) {
		this.getReducer().on(callback);
	}
	public on(callback: (reducerEvent: ReducerEvent, _elementId: number, _folderId: number | null) => void)
	{
		this.client.on("reducer:UpdateElementFolder", callback);
	}
}


export default UpdateElementFolderReducer
